import React from 'react';

import { RabbitTimePeriodDropdown } from 'components/RabbitTimePeriodDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedTimelines } from 'reducers/okrsPageSlice';
import { useGoalAnalytics } from 'screens/analytics/goals/GoalAnalyticsContext';
import { okrsPageSelector } from 'selectors/okrsPage';

import { sendClickedOnTimePeriodEvent } from 'constants/mixpanelHelper';

import { setTimeBoundsToLS } from '.';

export const TimelineDropdown = ({ isPageHeaderTimeline }) => {
  const { timelinesData, allTimelines, selectedTimelines } = useSelector(okrsPageSelector);

  const { updateTimeBoundPeriods } = useGoalAnalytics();
  const dispatch = useDispatch();

  return (
    <>
      {allTimelines?.length > 0 && selectedTimelines?.length > 0 ? (
        // later when requirement comes, this component will be able to select and render multiple time periods
        <RabbitTimePeriodDropdown
          timePeriodData={timelinesData}
          selectedTimeBoundPeriod={selectedTimelines?.[0] ?? null}
          setSelectedTimeBoundPeriod={(timePeriod) => {
            sendClickedOnTimePeriodEvent({
              eventProperties: {
                timePeriod: timePeriod?.timelineTag,
              },
            });
            dispatch(updateSelectedTimelines([timePeriod]));
            updateTimeBoundPeriods(timePeriod);

            setTimeBoundsToLS([timePeriod]);
          }}
          isPageHeaderTimeline={isPageHeaderTimeline}
        />
      ) : null}
    </>
  );
};
